import React from 'react';

const emptyImg = require('../../assets/images/empty.png');

export default function () {
    return (
      <div className='review-empty'>
        <img src={emptyImg} alt='空图片' />
        <p className='info-1'>暂无待评审项目</p>
        <p className='info-2'>您尚未被分配可评审的项目，若有问题请联系 huanbao@meituan.com</p>
      </div>
    );
  };